// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Json_encode from "../../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as TransactionType from "../../entity/TransactionType.bs.js";

function execute(request) {
  return Json_encode.object_({
              hd: [
                "txn_type",
                TransactionType.toString(request.transactionType)
              ],
              tl: {
                hd: [
                  "amount",
                  request.amount
                ],
                tl: {
                  hd: [
                    "reason_id",
                    Caml_format.caml_int_of_string(request.reason)
                  ],
                  tl: {
                    hd: [
                      "admin_comment",
                      request.admin_comment
                    ],
                    tl: {
                      hd: [
                        "partner_comment",
                        request.partner_comment
                      ],
                      tl: {
                        hd: [
                          "wallet_version_id",
                          request.walletVersionId
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

var AdminTransactionEncoder = {
  execute: execute
};

function encodePartnerRequest(partnerRequest) {
  return Json_encode.object_({
              hd: [
                "msisdn",
                partnerRequest.driver_msisdn
              ],
              tl: {
                hd: [
                  "vehicle_number",
                  partnerRequest.vehicle_number
                ],
                tl: {
                  hd: [
                    "amount",
                    partnerRequest.amount
                  ],
                  tl: {
                    hd: [
                      "partner_comment",
                      partnerRequest.partner_comment
                    ],
                    tl: {
                      hd: [
                        "admin_comment",
                        partnerRequest.admin_comment
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

function execute$1(request) {
  return Json_encode.object_({
              hd: [
                "city",
                request.city
              ],
              tl: {
                hd: [
                  "reason_enum",
                  request.reason
                ],
                tl: {
                  hd: [
                    "file_name",
                    request.file_name
                  ],
                  tl: {
                    hd: [
                      "partner_requests",
                      $$Array.map(encodePartnerRequest, $$Array.of_list(request.partner_requests))
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

var BulkUploadRequestEncoder = {
  encodePartnerRequest: encodePartnerRequest,
  execute: execute$1
};

export {
  AdminTransactionEncoder ,
  BulkUploadRequestEncoder ,
  
}
/* No side effect */
